import * as React from 'react';
import { getBrandingClass, ButtonStyle } from './button';

import { button } from './button.less';


export interface IAnchorProps extends React.HTMLProps<HTMLAnchorElement> {
	acceptanceTestTargetId: string;
	href: string;
	buttonStyle?: ButtonStyle;
	openNewTab?: boolean;
}

export const ButtonLink: React.StatelessComponent<IAnchorProps> = (props) => {
	const { children,
		buttonStyle = ButtonStyle.Primary,
		className = '',
		acceptanceTestTargetId,
		href,
		openNewTab,
		...anchorProps } = props;

	if (openNewTab) {
		anchorProps.target = '_blank';
		anchorProps.rel = 'noopener noreferrer';
	}

	const brandingClass = getBrandingClass(buttonStyle);

	return <a className={`${className} ${button} ${brandingClass}`} href={href} data-pp-at-target={acceptanceTestTargetId} {...anchorProps}>{children}</a>;
};
